"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketTaggingInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketTaggingInput.js.map